<template>
  <div class="body">
    <van-nav-bar title="订单详情" left-text left-arrow @click-left="onClickLeft" class="topNav"/>
    <div class="content">
      <van-tabs v-model="active" @click="change" color="#e9aea8">
        <van-tab title="快递配送">
          <SubOrder :data="orderData" :hasAddress="true" @buy="buy" @showmsg="showmsg"/>
        </van-tab>
        <van-tab title="上门自提" @click="change">
          <SubOrder :data="orderData" :hasAddress="false" @buy="buy" @showmsg="showmsg"/>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import SubOrder from "@/components/SubOrder.vue";
import { GetOrder, Buy, GetOrderOne, GWCBuy } from "../../apis/https.js";
import { getSessionStorage, getLocalStorage } from "../../utils/storage.js";
import { Tab, Tabs, Dialog } from "vant";

import Vue from "vue";
Vue.use(Tab).use(Tabs);
export default {
  components: {
    SubOrder
  },
  data() {
    return {
      orderData: {
        address: {
          name: "",
          phone: "",
          city: "",
          province: "",
          region: ""
        },
        goods: [],
        total_price: "",
        total_num: "",
        express_price: "",
        exist_address: false
      },
      shopid:null,
      active: 0,
      token: "",
      ids: "",
      delivery: 10,
      msg: "",
      type: 0,
      buyOne: {
        id: "",
        num: 0,
        skuid: ""
      }
    };
  },
  computed: {
    para() {
      return {
        ids: this.$store.state.order.ids,
        goods_id: this.$store.state.order.goods_id,
        goods_num: this.$store.state.order.goods_num,
        goods_sku_id: this.$store.state.order.goods_sku_id
      };
    }
  },
  created() {},
  activated() {
    // if(this.$route.query.active!=undefined){
    //   this.active=this.$route.query.active;
    // }
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    this.ids = this.para.ids;
    this.token = getLocalStorage("login_token");
    this.delivery = this.active == 0 ? 10 : 20;
    this.shopid = this.$store.state.system.shopid;
    if (
      this.para.ids == null &&
      this.para.goods_id == null &&
      this.para.goods_num == null &&
      this.para.goods_sku_id == null
    ) {
      this.$router.push("/pages/flow/index");
    } else if (this.para.ids != null) {
      this.type = 0;
      this.GetOrder(this.ids, this.delivery, this.shopid);
    } else {
      this.type = 1;
      this.buyOne.id = this.para.goods_id;
      this.buyOne.num = this.para.goods_num;
      this.buyOne.skuid = this.para.goods_sku_id;
      this.GetOrderOne(
        this.buyOne.id,
        this.buyOne.num,
        this.buyOne.skuid,
        this.delivery,
        this.shopid
      );
    }
  },
  mounted() {},
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    change(index, title) {
      if (index == 0) {
        this.delivery = 10;
      } else {
        this.delivery = 20;
      }
      if (this.ids != undefined) {
        this.GetOrder(this.ids, this.delivery, this.shopid);
      } else {
        this.GetOrderOne(
          this.buyOne.id,
          this.buyOne.num,
          this.buyOne.skuid,
          this.delivery,
          this.shopid
        );
      }
    },
    GetOrder(cart_ids, delivery, shop_id) {
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: "加载中"
      });
      GetOrder(cart_ids, delivery, shop_id, this.token)
        .then(res => {
          this.$toast.clear();
          let data = res.data;
          //初始化
          this.initializeData(data, delivery);
        })
        .catch(e => {});
    },
    buy() {
      // goods_id, goods_num, goods_sku_id, delivery, coupon_id, shop_id, remark, ali_pay,return_url,quit_url,token
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: "加载中"
      });
      if (this.type == 1) {
        Buy(
          this.buyOne.id,
          this.buyOne.num,
          this.buyOne.skuid,
          this.delivery,
          "",
          this.shopid,
          this.msg,
          "url",
          getLocalStorage("login_token")
        )
          .then(res => {
            location.href = res.data.payment.ali_pay_url;
          })
          .catch(e => {
            this.$toast.clear();
            this.$toast.fail("支付失败");
          });
      } else if (this.type == 0) {
        //ids, delivery, coupon_id, shop_id, remark, ali_pay,return_url,quit_url,token
        this.$toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true, // 禁用背景点击
          loadingType: "spinner",
          message: "加载中"
        });
        GWCBuy(
          this.ids,
          this.delivery,
          "",
          this.shopid,
          this.msg,
          "url",
          getLocalStorage("login_token")
        )
          .then(res => {
            location.href = res.data.payment.ali_pay_url;
          })
          .catch(e => {
            this.$toast.clear();
            if (res.msg == "请先选择收货地址") {
              this.$toast.fail("请先选择收货地址");
            } else {
              this.$toast.fail("支付失败");
            }
          });
      }
    },
    GetOrderOne(id, num, skuid, delivery, shop_id) {
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: "加载中"
      });
      GetOrderOne(
        id,
        num,
        skuid,
        delivery,
        shop_id,
        getLocalStorage("login_token")
      )
        .then(res => {
          this.$toast.clear();
          let data = res.data;
          this.initializeData(data, delivery);
        })
        .catch(e => {});
    },
    showmsg(res) {
      this.msg = res;
    },
    GWCBuy() {
      GWCBuy()
        .then(res => {})
        .catch(e => {});
    },
    initializeData(data, delivery) {
      Object.keys(this.orderData.address).map(
        key => (this.orderData.address[key] = "")
      );
      this.orderData.exist_address = false;
      //赋值
      if (delivery == 10) {
        this.orderData.exist_address = data.exist_address;
        if (this.orderData.exist_address) {
          this.orderData.address.name = data.address.name;
          this.orderData.address.phone = data.address.phone;
          this.orderData.address.city = data.address.region.city;
          this.orderData.address.province = data.address.region.province;
          this.orderData.address.region = data.address.region.region;
          this.orderData.address.detail = data.address.detail;
        }
      } else {
        if (this.$store.state.system.shopid != null) {
          this.orderData.exist_address=true;
          this.orderData.address.name = data.extract_shop.shop_name;
          this.orderData.address.city = data.extract_shop.region.city;
          this.orderData.address.province = data.extract_shop.region.province;
          this.orderData.address.region = data.extract_shop.region.region;
          this.orderData.address.detail = data.extract_shop.address;

        }
      }
      this.orderData.total_price = data.order_pay_price;
      this.orderData.total_num = data.order_total_num;
      this.orderData.express_price = data.express_price;
      this.orderData.goods = [];
      for (let i in data.goods_list) {
        this.orderData.goods.push({
          id: data.goods_list[i].goods_id,
          name: data.goods_list[i].goods_name,
          skuid: data.goods_list[i].goods_sku_id,
          img:
            data.goods_list[i].image[0].file_path ||
            data.goods_list[i].goods_image,
          num: data.goods_list[i].total_num,
          pirce: data.goods_list[i].total_price
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.body {
  background: #f4f8fb;
  min-height: 100vh;
  overflow: hidden;
  .topNav {
    position: fixed;
    width: 100%;
    top: 0px;
    i {
      color: #323233 !important;
    }
  }
  .content {
    margin-top: 46px;
  }
}
</style>